import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './App.css';

import { CartProvider } from './context/CartContext';
import { CustomerTypeProvider, useCustomerType } from './context/CustomerTypeContext';
import Navbar from './components/Navbar';
import Banner from './components/Banner';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import About from './pages/About';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import ShippingPolicy from './pages/ShippingPolicy';
import CancellationReturnPolicy from './pages/CancellationReturnPolicy';
import LeaveReview from './pages/LeaveReview';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const { customerType } = useCustomerType();
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (!customerType && !isAdminRoute && location.pathname !== '/') {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Banner />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/cancellation-returns" element={<CancellationReturnPolicy />} />
          <Route path="/leave-review" element={<LeaveReview />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
        <Footer />
        <CookieConsent />
      </div>
    </>
  );
}

function App() {
  return (
    <CustomerTypeProvider>
      <CartProvider>
        <Router>
          <AppContent />
        </Router>
      </CartProvider>
    </CustomerTypeProvider>
  );
}

export default App;
